import { listStaffEraseVideoSubtitleTasks } from "~/api/staff"
import {
  getVideoTaskColumns,
  VideoTaskListPage,
} from "~/pages/Staff/VideoTaskList"

const formatSubtitleHeightRange = (createParams: string) => {
  try {
    const params = JSON.parse(createParams) as {
      subtitle_filter?: {
        max_text_height_ratio?: unknown
        min_text_height_ratio?: unknown
      }
    }
    const minimum = params.subtitle_filter?.min_text_height_ratio
    const maximum = params.subtitle_filter?.max_text_height_ratio

    if (
      typeof minimum !== "number" ||
      !Number.isFinite(minimum) ||
      typeof maximum !== "number" ||
      !Number.isFinite(maximum) ||
      minimum < 0 ||
      maximum > 1 ||
      minimum > maximum
    ) {
      return "-"
    }

    return `${(minimum * 100).toFixed(2)}% – ${(maximum * 100).toFixed(2)}%`
  } catch {
    return "-"
  }
}

const columns = getVideoTaskColumns<API.Staff.StaffEraseVideoSubtitleTaskItem>({
  doneLabel: "去字幕完成",
  failedLabel: "去字幕失败",
  resultTitle: "去字幕结果",
  settingColumns: [
    {
      title: "字幕高度范围",
      dataIndex: "create_params",
      width: 165,
      render: formatSubtitleHeightRange,
    },
  ],
})

export const StaffEraseVideoSubtitleTaskList = () => (
  <VideoTaskListPage
    title="去字幕任务"
    description="查看视频去字幕任务的处理状态、字幕高度、输入输出视频和计费积点。"
    columns={columns}
    fetchPage={listStaffEraseVideoSubtitleTasks}
    errorMessage="去字幕任务加载失败，请稍后重试"
    defaultPageSize={10}
    pageSizeOptions={[10, 20, 30]}
  />
)
